module.exports = __webpack_public_path__ + "img/like-our-service.480bce98.svg";